<ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="trigger" [cdkConnectedOverlayOpen]="isOpen">
    <div [ngClass]="layout" class="overlay-container" (click)="onOverlayClick($event)">
        <div class="close">
            <button porAddFeature featureName="{{ featureName }}-close-open-overlay" class="theme-button cross-search" (click)="closeOverlay()"><span>X</span></button>
        </div>
        <ng-content></ng-content>
        <!-- Projected content from parent -->
    </div>
</ng-template>
